import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _uniqueId from "lodash/uniqueId";
import _omit from "lodash/omit";
import _isEqual from "lodash/isEqual";
import _get from "lodash/get";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { action, computed, observable, toJS as _toJS } from 'mobx';
import { showSuccessToast } from 'core/components/toast';
import api from 'core/util/api';
// we never serialize these fields to the API.
var EDITED_CREATED_FIELDS = ['edate', 'cdate'];
/**
 * Standard Model class.
 *
 * @typeParam T - should always be defined and represents the interface for this Model if this Model were a simple JSON object.
 * @typeParam D - `keyof defaults()`
 */
export var Model = (_dec = observable.shallow, _class = /*#__PURE__*/function () {
  function Model(attributes) {
    var _this = this;
    _classCallCheck(this, Model);
    _initializerDefineProperty(this, "error", _descriptor, this);
    this.optimisticId = _uniqueId('i_');
    this.attributes = void 0;
    /**
     * This is listed as public but it's probably best to treat it as protected - accessing collection indirectly like
     * this is pretty funky! Also note that you may need to cast this `as unknown as MyCollection` when you want to use
     * it externally.
     */
    // eslint-disable-next-line no-use-before-define
    this.collection = null;
    _initializerDefineProperty(this, "requestStatus", _descriptor2, this);
    _initializerDefineProperty(this, "requestProgress", _descriptor3, this);
    _initializerDefineProperty(this, "lastUpdated", _descriptor4, this);
    /**
     * Do not read this from outside of Collection/Model!
     */
    this.store = void 0;
    this.fetchMethod = void 0;
    /**
     * Questions whether the request exists and matches a certain label.
     * If no label are passed it will check if any requests are active.
     */
    this.isRequestActive = function (label) {
      if (!label) {
        return _this.requestStatus !== null;
      }
      return !!_this.requestStatus && _this.requestStatus === label || _this.collection && _this.collection.isRequestActive(label);
    };
    _initializerDefineProperty(this, "setRequestStatus", _descriptor5, this);
    /**
     * Set the current selected model in a collection to this model. Typically this
     * method is called from a UI with a direct reference to `this`, so we keep the
     * binding with an arrow function. `onClick={model.select}`
     */
    _initializerDefineProperty(this, "select", _descriptor6, this);
    _initializerDefineProperty(this, "deselect", _descriptor7, this);
    _initializerDefineProperty(this, "setLastUpdated", _descriptor8, this);
    /**
     * Replaces all of the attributes with new ones.
     */
    _initializerDefineProperty(this, "replace", _descriptor9, this);
    _initializerDefineProperty(this, "duplicate", _descriptor0, this);
    _initializerDefineProperty(this, "destroyModel", _descriptor1, this);
    /*
     * Very important to note that any fields used here, must be defined with getter syntax
     * in subclasses or they will be undefined here!
     */

    this.attributes = observable.object(Object.assign({}, this.defaults, attributes), {}, {
      deep: false,
      name: 'Model.attributes'
    });
  }
  return _createClass(Model, [{
    key: "urlPaths",
    get: function get() {
      return undefined;
    }
  }, {
    key: "defaults",
    get: function get() {
      return {};
    }

    /**
     * Return the base url used in the `url` method
     */
  }, {
    key: "urlRoot",
    get: function get() {
      return undefined;
    }
  }, {
    key: "omitDuringSerialize",
    get: function get() {
      return [];
    }
  }, {
    key: "messages",
    get: function get() {
      return {
        create: 'Added successfully',
        update: 'Updated successfully',
        destroy: 'Removed successfully',
        duplicate: 'Duplicated successfully'
      };
    }
  }, {
    key: "showToastTitles",
    get: function get() {
      return false;
    }
  }, {
    key: "index",
    get: function get() {
      if (!this.collection) {
        throw new Error('index: Model is not a part of a collection');
      }
      return this.collection.models.indexOf(this);
    }

    /**
     * Return the url for this given REST resource
     */
  }, {
    key: "url",
    get: function get() {
      var _this$urlRoot, _this$collection;
      if (!this.urlRoot && (!this.collection || !this.collection.url)) {
        throw new Error('No `urlRoot` provided');
      }
      var urlRoot = (_this$urlRoot = this.urlRoot) !== null && _this$urlRoot !== void 0 ? _this$urlRoot : (_this$collection = this.collection) === null || _this$collection === void 0 ? void 0 : _this$collection.url;
      if (!urlRoot) {
        // TODO should ideally be a compile-time error
        throw new Error('Model fetch attempted for model with no defined URL!');
      }
      if (this.isNew) {
        return urlRoot;
      }
      return "".concat(urlRoot, "/").concat(this.get('id'));
    }
  }, {
    key: "toDate",
    value: function toDate(_dateType) {
      return undefined;
    }
  }, {
    key: "lastEdited",
    get: function get() {
      return this.toDate('etime') || this.toDate('edate');
    }
  }, {
    key: "created",
    get: function get() {
      return this.toDate('ctime') || this.toDate('cdate');
    }

    /**
     * Whether the resource is new or not
     *
     * We determine this asking if it contains the `id` attribute (set by the server).
     */
  }, {
    key: "isNew",
    get: function get() {
      return !this.has('id') || !this.get('id') && this.get('id') !== 0;
    }

    /**
     * Determines whether or not this Model is selectable in it's collection.
     */
  }, {
    key: "isSelectable",
    get: function get() {
      return true;
    }

    /**
     * Determines whether or not this Model is selected in it's collection.
     */
  }, {
    key: "isSelected",
    get: function get() {
      if (!this.collection) {
        console.warn("BaseModel (".concat(this.constructor.name, ") is not a part of a Collection. Cannot call isSelected()"));
        return false;
      }
      var selected = this.collection.selected;
      if (Array.isArray(selected)) {
        return selected.includes(this);
      }
      return this.collection.selected === this;
    }

    /**
     * Get an id from the model. It will use either
     * the backend assigned one or the client.
     */
  }, {
    key: "id",
    get: function get() {
      if (this.has('id')) {
        var _this$get;
        // probably this is the only line we need but I've kept this in for possible legacy issues
        return (_this$get = this.get('id')) !== null && _this$get !== void 0 ? _this$get : this.optimisticId;
      }
      return this.optimisticId;
    }
  }, {
    key: "baseGet",
    value: function baseGet(attribute) {
      var _this2 = this;
      if (!attribute) {
        return _toJS(this.attributes);
      }
      if (typeof attribute === 'string' && attribute.includes('.')) {
        var _attribute$split = attribute.split('.'),
          _attribute$split2 = _toArray(_attribute$split),
          r = _attribute$split2[0],
          rest = _arrayLikeToArray(_attribute$split2).slice(1);
        var root = r;
        // ignore dot in keys attributes like `f_hll(inet_src_addr,0.0001)__k_last`
        if (!this.attributes[root] && this.has(attribute)) {
          return this.attributes[attribute];
        }
        if (rest.length === 1) {
          // @ts-expect-error left in for legacy purposes but please do not use this - TS won't let you do it safely!
          return this.attributes[root] && this.attributes[root][rest[0]];
        }
        return this.attributes[root] && _get(this.attributes[root], rest.join('.'));
      }
      if (Array.isArray(attribute)) {
        return attribute.reduce(function (result, attr) {
          if (attr.includes('.')) {
            var _attr$split = attr.split('.');
            var _attr$split2 = _slicedToArray(_attr$split, 1);
            attr = _attr$split2[0];
          }
          result[attr] = _this2.attributes[attr];
          return result;
        }, {});
      }
      return this.attributes[attribute];
    }
  }, {
    key: "get",
    value:
    /**
     * Get the attribute from the model.
     *
     * For optional fields use `has()` to check whether the field is populated.
     * If no attribute is passed, returns all of the model attributes as a plain object.
     */
    function get(attribute, defaultValue) {
      if (!attribute) {
        return this.baseGet() || defaultValue;
      }
      var result = this.baseGet(attribute);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Returns whether the given field exists for the model.
     */
  }, {
    key: "has",
    value: function has(attribute) {
      return this.attributes[attribute] !== undefined && this.attributes[attribute] !== null;
    }
  }, {
    key: "sortValues",
    get: function get() {
      return {};
    }
  }, {
    key: "getSortValue",
    value: function getSortValue(field) {
      var _value;
      if (!field) {
        return '';
      }
      var value;
      if (this.sortValues[field]) {
        value = this.sortValues[field](this);
      } else {
        value = this.get(field);
        if (value === undefined) {
          value = this[field];
        }
      }

      // Replacing undefined with empty string makes _.orderBy happy when ordering numbers and strings
      return typeof value === 'number' ? value : ((_value = value) === null || _value === void 0 ? void 0 : _value.toString()) || '';
    }

    /**
     * Returns a raw JS instance of our Model, used for debugging purposes mostly.
     */
  }, {
    key: "toJS",
    value: function toJS() {
      return _toJS(this.attributes);
    }
  }, {
    key: "isEqual",
    value: function isEqual(otherModel) {
      return otherModel && otherModel.toJS && _isEqual(this.toJS(), otherModel.toJS());
    }
  }, {
    key: "safeSet",
    value:
    /**
     * Merge the given data with the current attributes.
     *
     * Does NOT merge `undefined` values as this can break type safety! Unfortunately there
     * is not an easy way to define a Partial type which does not allow "defined undefined" values.
     *
     * One day we might want to convert the regular `set()` method to follow this pattern but if so
     * then we can just do a find & replace.
     */
    function safeSet(data) {
      for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value !== undefined) {
          this.attributes[key] = value;
        }
      }
      this.setLastUpdated();
      return this;
    }

    /**
     * Merge the given data with the current attributes
     * @deprecated see `this.safeSet(data)`
     */
  }, {
    key: "set",
    value:
    /**
     * Merge the given data with the current attributes
     */
    function set() {
      var dataOrFieldName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fieldData = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof dataOrFieldName === 'string' && fieldData != null) {
        this.attributes[dataOrFieldName] = fieldData;
      } else {
        Object.assign(this.attributes, dataOrFieldName);
      }
      this.setLastUpdated();
      return this;
    }
  }, {
    key: "save",
    value: (
    /**
     * Saves the resource on the backend.
     *
     * If the item has an `id` it updates it, otherwise it creates the new resource.
     *
     * It supports optimistic and patch updates.
     *
     * @param attributes
     * @param options
     * @param options.optimistic - updates the model before we get a response back from the server.
     * @param options.patch - uses `PATCH` versus `PUT`.
     */
    function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(attributes) {
        var _this3 = this;
        var options,
          _options$optimistic,
          optimistic,
          _options$patch,
          patch,
          _options$preserialize,
          preserialize,
          _options$setOnPatchSu,
          setOnPatchSuccess,
          _options$clearSelecti,
          clearSelection,
          _options$toast,
          toast,
          toastMessage,
          _options$sendProvided,
          sendProvidedValuesOnly,
          url,
          data,
          originalAttributes,
          saveUrl,
          apiMethod,
          promise,
          _args = arguments;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _options$optimistic = options.optimistic, optimistic = _options$optimistic === void 0 ? false : _options$optimistic, _options$patch = options.patch, patch = _options$patch === void 0 ? false : _options$patch, _options$preserialize = options.preserialize, preserialize = _options$preserialize === void 0 ? true : _options$preserialize, _options$setOnPatchSu = options.setOnPatchSuccess, setOnPatchSuccess = _options$setOnPatchSu === void 0 ? true : _options$setOnPatchSu, _options$clearSelecti = options.clearSelection, clearSelection = _options$clearSelecti === void 0 ? true : _options$clearSelecti, _options$toast = options.toast, toast = _options$toast === void 0 ? true : _options$toast, toastMessage = options.toastMessage, _options$sendProvided = options.sendProvidedValuesOnly, sendProvidedValuesOnly = _options$sendProvided === void 0 ? false : _options$sendProvided, url = options.url;
              this.requestStatus = 'updating';
              this.requestProgress = 0;
              if (!this.isNew) {
                _context.next = 1;
                break;
              }
              this.set(Object.assign({}, attributes));
              return _context.abrupt("return", this.create(attributes, {
                optimistic: optimistic,
                toast: toast,
                clearSelection: clearSelection,
                url: url
              }));
            case 1:
              data = attributes;
              originalAttributes = this.get(); // if PATCH, we only want to send the values that changed.
              if (patch) {
                data = Object.keys(attributes).reduce(function (result, att) {
                  var attribute = att;
                  var newValue = attributes[attribute];
                  var oldValue = originalAttributes[attribute];
                  if (newValue !== oldValue) {
                    // @ts-expect-error TODO this is pretty unsafe and can result in accidental data deletion! but also very hard to rewrite
                    result[attribute] = newValue;
                  }
                  return result;
                }, {});
              } else if (!sendProvidedValuesOnly) {
                data = Object.assign({}, originalAttributes, attributes);
              }
              if (optimistic) {
                this.set(attributes);
              }
              saveUrl = url || (this.urlPaths ? this.urlPaths.update : this.url);
              apiMethod = patch ? 'patch' : 'put';
              promise = api[apiMethod](saveUrl, {
                data: preserialize ? this.serialize(data) : data
              });
              return _context.abrupt("return", promise.then(function (success) {
                if (_this3.collection && clearSelection) {
                  _this3.collection.clearSelection();
                }
                if (!patch || setOnPatchSuccess) {
                  _this3.set(_this3.deserialize(success));
                }
                if (toast) {
                  showSuccessToast(toastMessage || _this3.messages.update, {
                    title: _this3.showToastTitles ? 'Updated' : undefined
                  });
                }
                if (_this3.collection) {
                  _this3.collection.setLastUpdated();
                }
                _this3.setLastUpdated();
                _this3.requestStatus = null;
                return success;
              }, function (error) {
                if (optimistic) {
                  _this3.set(originalAttributes);
                }
                _this3.error = {
                  label: 'updating'
                };
                _this3.requestStatus = null;
                throw error;
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function save(_x) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
    /**
     * Saves this new model on the backend (via POST operation)
     */
    )
  }, {
    key: "create",
    value: (function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;
        var attributes,
          options,
          label,
          data,
          clearSelection,
          _options$toast2,
          toast,
          url,
          payload,
          promise,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              attributes = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              label = 'creating';
              data = Object.assign({}, this.get(), attributes);
              clearSelection = options.clearSelection, _options$toast2 = options.toast, toast = _options$toast2 === void 0 ? true : _options$toast2;
              url = options.url || (this.collection && this.collection.url ? this.collection.url : this.urlRoot);
              if (url) {
                _context2.next = 1;
                break;
              }
              throw new Error('Attempted to save Model with no defined URL');
            case 1:
              payload = this.serialize(data);
              promise = api.post(url, {
                data: payload
              });
              this.requestStatus = label;
              return _context2.abrupt("return", promise.then(function (success) {
                _this4.set(_this4.deserialize(success));
                if (_this4.collection) {
                  _this4.collection.add([_this4]);
                  if (clearSelection) {
                    _this4.collection.clearSelection();
                    _this4.collection.sort(); // Note: it seemed to make sense not to re-apply existing filter rules
                  }
                }
                if (toast) {
                  var createMessage = _this4.messages ? _this4.messages.create : 'Created Successfully';
                  showSuccessToast(createMessage, {
                    title: _this4.showToastTitles ? 'Created' : undefined
                  });
                }
                _this4.requestStatus = null;
                return success;
              }, function (error) {
                _this4.error = {
                  label: label,
                  body: error
                };
                _this4.requestStatus = null;
                throw error;
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }())
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;
        var options,
          label,
          url,
          apiFetchMethod,
          promise,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              label = 'fetching';
              this.requestStatus = label;
              this.requestProgress = 0;
              url = this.urlPaths ? this.urlPaths.fetch : this.url;
              apiFetchMethod = this.fetchMethod === 'post' ? api.post : api.get;
              promise = apiFetchMethod(url, options);
              return _context3.abrupt("return", promise.then(function (success) {
                _this5.set(_this5.deserialize(success));
                _this5.setRequestStatus(null);
                return success;
              }, function (error) {
                _this5.error = {
                  label: label,
                  body: error
                };
                _this5.requestStatus = null;
                throw error;
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetch() {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "destroy",
    value: (
    /**
     * Destroys the resource on the client and requests the backend to delete it there too
     */
    function () {
      var _destroy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var options,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              if (!this.collection) {
                _context4.next = 1;
                break;
              }
              if (!(this.isNew || !this.urlRoot)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return", Promise.resolve(this.collection.remove([this.id.toString()])));
            case 1:
              return _context4.abrupt("return", this.destroyModel(options));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }())
  }, {
    key: "serialize",
    value: function serialize(data) {
      return _omit(data || this.get(), [].concat(_toConsumableArray(this.omitDuringSerialize), EDITED_CREATED_FIELDS));
    }
  }, {
    key: "jsonRoot",
    get: function get() {
      return undefined;
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return data && this.jsonRoot ? data[this.jsonRoot] : data;
    }
  }, {
    key: "getUniqueCopyName",
    value: function getUniqueCopyName(nameField) {
      var _this$get2;
      var name = ((_this$get2 = this.get(nameField)) === null || _this$get2 === void 0 ? void 0 : _this$get2.toString()) || '';
      if (this.collection) {
        // Remove the [Copy] or [Copy x] from the name
        var nameMatch = name.match(/\[Copy.*\] (.+)/);
        if (nameMatch) {
          name = nameMatch[nameMatch.length - 1];
        }
        if (!this.collection.find(_defineProperty({}, nameField, "[Copy] ".concat(name)))) {
          return "[Copy] ".concat(name);
        }
        for (var i = 1;; i += 1) {
          if (!this.collection.find(_defineProperty({}, nameField, "[Copy ".concat(i, "] ").concat(name)))) {
            return "[Copy ".concat(i, "] ").concat(name);
          }
        }
      }
      return name;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "error", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requestStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "requestProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "lastUpdated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "index", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "index"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastEdited", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastEdited"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "created", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "created"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNew", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNew"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelected"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "setRequestStatus", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (status) {
      _this6.requestStatus = status;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "select", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$multi = options.multi,
        multi = _options$multi === void 0 ? false : _options$multi,
        _options$shiftKey = options.shiftKey,
        shiftKey = _options$shiftKey === void 0 ? false : _options$shiftKey,
        _options$fetch = options.fetch,
        fetch = _options$fetch === void 0 ? false : _options$fetch;
      if (!_this7.collection) {
        console.warn("BaseModel (".concat(_this7.constructor.name, ") is not a part of a Collection. Cannot call select()"));
      }
      if (!_this7.isSelectable) {
        return Promise.resolve();
      }
      if (fetch) {
        return _this7.fetch().then(function () {
          var _this7$collection;
          (_this7$collection = _this7.collection) === null || _this7$collection === void 0 || _this7$collection.select(_this7, {
            multi: multi
          });
        });
      }
      return Promise.resolve().then(function () {
        var _this7$collection2;
        return (_this7$collection2 = _this7.collection) === null || _this7$collection2 === void 0 ? void 0 : _this7$collection2.select(_this7, {
          multi: multi,
          shiftKey: shiftKey
        });
      });
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "deselect", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      var _this8$collection;
      if (!_this8.collection) {
        console.warn("Model (".concat(_this8.constructor.name, ": ").concat(_this8.id, ") is not a part of a Collection. Cannot call select()"));
      }
      if (!_this8.isSelected) {
        console.warn("Model (".concat(_this8.constructor.name, ": ").concat(_this8.id, ") is not selected."));
      }
      (_this8$collection = _this8.collection) === null || _this8$collection === void 0 || _this8$collection.clearSelection();
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "setLastUpdated", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      _this9.lastUpdated = Date.now();
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "safeSet", [action], Object.getOwnPropertyDescriptor(_class.prototype, "safeSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "set", [action], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "replace", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this0 = this;
    return function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // @ts-expect-error difficult to get typing in here right now, needs reworking
      _this0.attributes = observable.object(data, {}, {
        deep: false,
        name: 'Model.attributes'
      });
      _this0.setLastUpdated();
    };
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "duplicate", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this1 = this;
    return function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$removeId = options.removeId,
        removeId = _options$removeId === void 0 ? true : _options$removeId,
        _options$save = options.save,
        save = _options$save === void 0 ? true : _options$save,
        _options$deserialize = options.deserialize,
        deserialize = _options$deserialize === void 0 ? true : _options$deserialize;
      var attributes = removeId ? _omit(_this1.get(), ['id']) : _this1.get();
      if (!_this1.collection) {
        return new Model(attributes);
      }
      var dupe = _this1.collection.build(attributes, {
        deserialize: deserialize
      });
      if (save) {
        dupe.save(attributes);
      }
      return dupe;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "create", [action], Object.getOwnPropertyDescriptor(_class.prototype, "create"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetch"), _class.prototype), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "destroyModel", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this10$collection;
      var options,
        _options$toast3,
        toast,
        _options$remove,
        remove,
        url,
        data,
        destroyUrl,
        _args5 = arguments;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
            _options$toast3 = options.toast, toast = _options$toast3 === void 0 ? true : _options$toast3, _options$remove = options.remove, remove = _options$remove === void 0 ? true : _options$remove, url = options.url, data = options.data;
            destroyUrl = url || ((_this10$collection = _this10.collection) !== null && _this10$collection !== void 0 && (_this10$collection = _this10$collection.urlPaths) !== null && _this10$collection !== void 0 && _this10$collection.destroy ? "".concat(_this10.collection.urlPaths.destroy, "/").concat(_this10.get('id')) : _this10.url);
            _this10.requestStatus = 'destroying';
            return _context5.abrupt("return", api.del(destroyUrl, data ? {
              data: data
            } : undefined).then(action(function (success) {
              if (toast) {
                showSuccessToast(_this10.messages.destroy, {
                  title: _this10.showToastTitles ? 'Removed' : undefined
                });
              }
              if (_this10.collection) {
                if (remove) {
                  _this10.collection.remove([_this10.id.toString()]);
                }
                _this10.collection.clearSelection();
              }
              _this10.requestStatus = null;
              return success;
            }), action(function (error) {
              console.error('destroyModel error', error);
              if (options.optimistic && _this10.collection) {
                _this10.collection.add([_this10.get()]);
              }
              _this10.error = {
                label: 'destroying',
                body: error
              };
              _this10.requestStatus = null;
              return error;
            })));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  }
}), _class);

/**
 * A concrete, non-generic version of the Model class that can be
 * easily instantiated from JavaScript files.
 *
 * @deprecated for future code it is generally preferable to create your own type-safe Model
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var GenericModel = /*#__PURE__*/function (_Model2) {
  function GenericModel() {
    _classCallCheck(this, GenericModel);
    return _callSuper(this, GenericModel, arguments);
  }
  _inherits(GenericModel, _Model2);
  return _createClass(GenericModel);
}(Model);
export { GenericModel as default };